import ManageResourceMenu from "@pathwright/web/src/modules/resource/manage/ManageResourceMenu"

const ManageResourceMenuContainer = (props) => {
  return (
    <ManageResourceMenu
      fetchPolicy="network-only"
      card={props.card}
      pathname={props.location.pathname}
      id={parseInt(props.match.params.resourceId)}
      // resource={props.}
      onSubmitSuccess={() => {
        // trigger resource:updated so store-connected UIs update
        return window.App.getStore("resourceAdmin")
          .action.loadResource(parseInt(props.match.params.resourceId), true)
          .promise.then(() =>
            window.App.getStore("resourceAdmin").storeTrigger(
              "resource:updated"
            )
          )
      }}
    />
  )
}

export default ManageResourceMenuContainer
